import React from 'react';
import AreaIndicatorChart from './AreaIndicatorChart';
import QuantitativeChartFactory from '../../charting/quant/QuantitativeChartFactory';

const Quantitative_AreaIndicatorChart = ({ areaIndicator }) => {
    return (
        <AreaIndicatorChart 
            areaIndicator={areaIndicator} 
            ChartFactory={QuantitativeChartFactory} 
            indicatorType="QUANTITATIVE" 
        />
    );
};

export default Quantitative_AreaIndicatorChart;